import React from 'react';
import { View, Text } from 'react-native';

import Link from 'gatsby-link';
import Helmet from 'react-helmet';

const HTMLHeader = ({ lang, page }) => {
    const fosol_title = `${lang.TITLE} ${page ? ' | ' + lang[page] : ''}`;
    const image = `https://fosol.com/fosol_card_${lang.CODE}.png`;
    const url = `https://fosol.com/${lang.CODE}/`;
    return (
        <Helmet>
            <html lang={lang.CODE} dir={lang.DIR} />
            {/* General tags */}
            <title>{fosol_title}</title>
            <meta name="description" content={lang.DESCRIPTION} />
            <meta name="keywords" content={lang.KEYWORDS} />
            <meta name="author" content={lang.TITLE} />
            <meta name="image" content={image} />
            <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
            <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
            <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
            <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#578bc1" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />

            {/* OpenGraph tags */}
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fosol_title} />
            <meta property="og:description" content={lang.DESCRIPTION} />
            <meta property="og:image" content={image} />

            {/* Twitter Card tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fosol_title} />
            <meta name="twitter:description" content={lang.DESCRIPTION} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default HTMLHeader;



// WEBPACK FOOTER //
// ./src/comp/helmet.js